import React from "react";
import { connect } from "react-redux";
import "react-phone-number-input/rrui.css";
import "react-phone-number-input/style.css";

//Parse
import { Parse } from "parse";

import UploadAvatar from "./uploadAvatar";

//moment
import moment from "moment";

//Action Creators
import { onChangeChecked, submitForm } from "../Actions/profileActionCreators";

//CSS & styles
import "../style.less";

// antd components
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Icon,
  Input,
  message,
  Select,
  Tooltip
} from "antd";

const FormItem = Form.Item;
const Option = Select.Option;

//moment

const dateFormat = "DD/MM/YYYY";
var birthDate = moment().subtract(18, "years");
const dateConfig = {
  rules: [
    {
      type: "object",
      required: true,
      message: "Merci d'indiquer votre date de naissance"
    }
  ],
  initialValue: moment(birthDate, dateFormat)
};

class SignUpForm extends React.Component {
  constructor(props) {
    super(props);
    //var ctx = this;

    //initialisation des states. Ils ne servent que de manière "temporaire" (test de condition pour "vider" les champs grâce
    // aux fonctions EmitEmpty.
    // Afin d'être persistants, ils doivent se transformer en props via le dispatch du Formulaire.
    this.state = {
      firstName: null,
      lastName: null,
      nickName: null,
      gender: null,
      birthDate: null,
      hideAge: false,
      phone: null,
      height: null,
      weight: null,
      adresse: null,
      professional: false,
      desc: null,
      ptsFidelity: 0,
      formLayout: "horizontal"
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeFirstName = this.onChangeFirstName.bind(this);
    this.onChangeLastName = this.onChangeLastName.bind(this);
    this.onChangeNickName = this.onChangeNickName.bind(this);
    this.onChangeGender = this.onChangeGender.bind(this);
    this.onChangeHeight = this.onChangeHeight.bind(this);
    this.onChangeWeight = this.onChangeWeight.bind(this);
    this.onChangeAdresse = this.onChangeAdresse.bind(this);
    this.onChangeCity = this.onChangeCity.bind(this);
    this.onChangePostcode = this.onChangePostcode.bind(this);
    this.onChangeHideAge = this.onChangeHideAge.bind(this);
    this.onChangeProfessional = this.onChangeProfessional.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePhone = this.onChangePhone.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onChangeTerms = this.onChangeTerms.bind(this);
    this.onChangeDesc = this.onChangeDesc.bind(this);
    this.chooseStepsChild = this.chooseStepsChild.bind(this);
  }

  async componentDidMount() {
    let currentUser = await Parse.User.current().fetch();
    let attributes = currentUser.attributes;

    if (attributes.firstName !== undefined) {
      this.setState({ firstName: attributes.firstName });
    }
    if (attributes.lastName !== undefined) {
      this.setState({ lastName: attributes.lastName });
    }
    if (attributes.nickName !== undefined) {
      this.setState({ nickName: attributes.nickName });
    }
    if (attributes.gender !== undefined) {
      this.setState({ gender: attributes.gender });
    }
    if (attributes.birthDate !== undefined) {
      this.setState({ birthDate: attributes.birthDate._d });
    }
    if (attributes.phone !== undefined) {
      this.setState({ phone: attributes.phone });
    }
    if (attributes.height !== undefined) {
      this.setState({ height: attributes.height });
    }
    if (attributes.weight !== undefined) {
      this.setState({ weight: attributes.weight });
    }
    if (attributes.adresse !== undefined) {
      this.setState({ adresse: attributes.adresse });
    }
    if (attributes.city !== undefined) {
      this.setState({ city: attributes.city });
    }
    if (attributes.postcode !== undefined) {
      this.setState({ postcode: attributes.postcode });
    }
    if (attributes.professional !== undefined) {
      this.setState({ professional: attributes.professional });
      this.chooseStepsChild(attributes.professional);
    }
    if (attributes.desc !== undefined) {
      this.setState({ desc: attributes.desc });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((error, values) => {
      if (error) {
        message.error("Le formulaire est incomplet");
      } else {
        message.success("Première étape validée !");
        this.props.submitForm(values);
        this.props.next1();
      }
      //mettre dispatch ?
    });
  };

  //changer le state de l'elem
  onChangeFirstName = e => {
    this.setState({ firstName: e.target.value });
    this.props.form.setFieldsValue({ firstName: this.state.firstName });
  };

  onChangeLastName = e => {
    this.setState({ lastName: e.target.value });
    this.props.form.setFieldsValue({ lastName: this.state.lastName });
  };

  onChangeNickName = e => {
    this.setState({ nickName: e.target.value });
    this.props.form.setFieldsValue({ nickName: this.state.nickName });
  };

  onChangeGender = e => {
    this.setState({ gender: e });
    this.props.form.setFieldsValue({ gender: this.state.gender });
  };

  onChangeHeight = e => {
    this.setState({ height: e });
    this.props.form.setFieldsValue({ height: this.state.height });
  };

  onChangeWeight = e => {
    this.setState({ weight: e });
    this.props.form.setFieldsValue({ weight: this.state.weight });
  };

  onChangeAdresse = e => {
    this.setState({ adresse: e });
    this.props.form.setFieldsValue({ adresse: this.state.adresse });
  };
  onChangeCity = e => {
    this.setState({ city: e });
    this.props.form.setFieldsValue({ city: this.state.city });
  };

  onChangePostcode = e => {
    this.setState({ postcode: e });
    this.props.form.setFieldsValue({ postcode: this.state.postcode });
  };

  onChangeDesc = e => {
    this.setState({ desc: e });
    this.props.form.setFieldsValue({ desc: this.state.desc });
  };

  onChangeHideAge = e => {
    this.setState({ hideAge: e });
    this.props.onHideAge();
  };

  onChangeProfessional = e => {
    this.setState({ professional: e.target.checked });
    this.props.form.setFieldsValue({ professional: e.target.checked });
    this.chooseStepsChild(e.target.checked);
  };

  chooseStepsChild = e => {
    this.props.chooseSteps(e);
  };

  onChangeEmail = e => {
    let autoCompleteResult;
    if (!e || e.includes("@")) {
      autoCompleteResult = [];
    } else {
      autoCompleteResult = [
        "@gmail.com",
        "@hotmail.fr",
        "@hotmail.com",
        "@yahoo.fr"
      ].map(domain => `${e}${domain}`);
    }
    this.setState({ autoCompleteResult });
    this.props.form.setFieldsValue({ email: autoCompleteResult });
  };

  onChangePhone = e => {
    this.setState({ phone: e });
  };

  onChangeDescription = e => {
    this.setState({
      description: e.target.value
    });
  };

  onChangeTerms(e) {
    this.props.form.setFieldsValue({ tos: e.target.checked });
  }

  ///   Emit Empty pour vider les champs texte
  emitEmptyFirstName = () => {
    this.setState({ firstName: null });
    this.props.form.setFieldsValue({ firstName: null });
  };

  emitEmptyLastName = () => {
    this.setState({ lastName: null });
    this.props.form.setFieldsValue({ lastName: null });
  };

  emitEmptyNickName = () => {
    this.setState({ nickName: null });
    this.props.form.setFieldsValue({ nickName: null });
  };

  emitEmptyEmail = () => {
    this.setState({ email: null });
    this.props.form.setFieldsValue({ email: null });
  };

  emitEmptyCity = () => {
    this.setState({ city: null });
    this.props.form.setFieldsValue({ city: null });
  };

  emitEmptypostcode = () => {
    this.setState({ postcode: null });
    this.props.form.setFieldsValue({ postcode: null });
  };

  emitEmptyDesc = () => {
    this.setState({ desc: null });
    this.props.form.setFieldsValue({ desc: null });
  };

  onChangeAvatar = file => {
    this.props.form.setFieldsValue({ picture: file });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    /*        const redirectToSignUp = this.props.user.redirectToSignUp

        if (redirectToSignUp === false) {
           return <Redirect to='/'/>;
         }*/

    var ctx = this;

    const suffixFirstName =
      ctx.state.firstName != null && ctx.state.firstName.length > 0 ? (
        <Icon type="close-circle" onClick={this.emitEmptyFirstName} />
      ) : null;

    const suffixLastName =
      ctx.state.lastName != null && ctx.state.lastName.length > 0 ? (
        <Icon type="close-circle" onClick={this.emitEmptyLastName} />
      ) : null;

    const suffixNickName =
      ctx.state.nickName != null && ctx.state.nickName.length > 0 ? (
        <Icon type="close-circle" onClick={this.emitEmptyNickName} />
      ) : null;

    const suffixAdresse =
      ctx.state.adresse != null && ctx.state.adresse.length > 0 ? (
        <Icon type="close-circle" onClick={this.emitEmptyAdresse} />
      ) : null;

    const suffixCity =
      ctx.state.city != null && ctx.state.adresse.length > 0 ? (
        <Icon type="close-circle" onClick={this.emitEmptyCity} />
      ) : null;

    const suffixpostcode =
      ctx.state.postcode != null && ctx.state.adresse.length > 0 ? (
        <Icon type="close-circle" onClick={this.emitEmptypostcode} />
      ) : null;

    const suffixDesc =
      ctx.state.desc != null && ctx.state.desc.length > 0 ? (
        <Icon type="close-circle" onClick={this.emitEmptyDesc} />
      ) : null;
    function disabledDate(current) {
      var a = moment().subtract(18, "year");
      // Can not select days before today and today
      return current && current > a;
    }
    //il faut que je fasse .ant-col-sm : 8 dans le wrapperCol
    //puis marginright80% c
    const { formLayout } = this.state;
    const formItemLayout =
      formLayout === "horizontal"
        ? {
            labelCol: {
              xs: { span: 20 },
              sm: { span: 4 }
            },
            wrapperCol: {
              xs: { span: 20 },
              sm: { span: 8 }
            }
          }
        : null;
    return (
      <Form
        layout={formLayout}
        onSubmit={this.handleSubmit}
        style={{ maringTop: "10px" }}
      >
        <FormItem {...formItemLayout} label="Votre prénom">
          {getFieldDecorator("firstName", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer votre prénom"
              }
            ],
            onChange: this.onChangeFirstName,
            initialValue: ctx.state.firstName
          })(<Input placeholder={"Prénom"} suffix={suffixFirstName} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre nom">
          {getFieldDecorator("lastName", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer votre nom"
              }
            ],
            onChange: this.onChangeLastName,
            initialValue: ctx.state.lastName
          })(<Input placeholder={"Nom de famille"} suffix={suffixLastName} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre pseudo">
          {getFieldDecorator("nickName", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer un pseudo"
              }
            ],
            onChange: this.props.onChangeNickName,
            initialValue: ctx.state.nickName
          })(<Input maxLength="38" suffix={suffixNickName} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre sexe">
          {getFieldDecorator("gender", {
            rules: [{ required: true, message: "Merci d'indiquer votre sexe" }],
            initialValue: ctx.state.gender
          })(
            <Select
              style={{ width: 200 }}
              placeholder="Choisir votre genre"
              onChange={this.onChangeGender}
            >
              <Option value={0}>Femme</Option>
              <Option value={1}>Homme</Option>
              <Option value={2}>Autre</Option>
            </Select>
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre adresse">
          {getFieldDecorator("adresse", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer votre adresse"
              }
            ],
            onChange: this.props.onChangeAdresse,
            initialValue: ctx.state.adresse
          })(<Input suffix={suffixAdresse} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre ville">
          {getFieldDecorator("city", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer votre ville"
              }
            ],
            onChange: this.props.onChangeCity,
            initialValue: ctx.state.city
          })(<Input suffix={suffixCity} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre code postal">
          {getFieldDecorator("postcode", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer votre code postal"
              }
            ],
            onChange: this.props.onChangePostcode,
            initialValue: ctx.state.postcode
          })(<Input suffix={suffixpostcode} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre date de naissance">
          {getFieldDecorator("birthDate", dateConfig)(
            <DatePicker
              style={{ width: 200 }}
              format={dateFormat}
              placeholder="Choisir une date"
              disabledDate={disabledDate}
            />
          )}
          <Tooltip title="Il faut avoir plus de 18 ans pour s'inscrire !">
            <Icon
              type="question-circle-o"
              style={{ paddingLeft: "1.5vh", fontSize: 16, color: "#00cccc" }}
            />
          </Tooltip>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Votre photo de profil"
          extra="Choisissez une photo de profil de format carré ou elle sera déformée !"
        >
          {getFieldDecorator("picture", {
            rules: [{ required: true }]
          })(<UploadAvatar onChange={this.onChangeAvatar} />)}
        </FormItem>

        <FormItem {...formItemLayout} label="Votre description">
          {getFieldDecorator("desc", {
            onChange: this.onChangeDesc,
            initialValue: ctx.state.desc
          })(<Input placeholder={"Description"} suffix={suffixDesc} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre numéro de téléphone">
          {getFieldDecorator("phone", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer votre numéro de téléphone"
              }
            ],
            initialValue: ctx.state.phone
          })(
            <Input
              placeholder="Votre numéro de téléphone"
              onChange={this.onChangePhone}
            />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Votre parrain/marraine"
          extra="Si c'est un UrbanFitteur qui vous a recommandé, indiquez son prénom et nom ici !"
        >
          {getFieldDecorator("parrainage")(
            <Input placeholder="Prénom et nom de votre parrain / marraine" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("professional")(
            <Checkbox
              checked={ctx.state.professional}
              onChange={this.onChangeProfessional}
            >
              Vous êtes professionel ? Cochez cette case
            </Checkbox>
          )}
        </FormItem>
        <Button
          style={{ marginLeft: "8px", marginTop: "5px", marginBottom: "25px" }}
          type="primary"
          htmltype="submit"
          onClick={this.handleSubmit}
        >
          {" "}
          Continuer{" "}
        </Button>
      </Form>
    );
  }
}

function saveParseUserStep1(values) {
  // The user was retrieved successfully.
  console.log("professional values : ", values.professional);
  var currentUser = Parse.User.current();
  var sessionToken = currentUser.getSessionToken();
  Parse.User.become(sessionToken).then(function(user) {
    user.set("firstName", values.firstName);
    user.set("lastName", values.lastName);
    user.set("nickName", values.nickName);
    user.set("gender", values.gender);
    user.set("birthDate", values.birthDate._d);
    user.set("email", values.email);
    user.set("adresse", values.adresse);
    user.set("city", values.city);
    user.set("postcode", values.postcode);
    user.set("avatar", values.picture);
    user.set("phone", values.phone);
    user.set("parrainage", values.parrainage);
    user.set("professional", values.professional);
    user.set("desc", values.desc);
    user.set("ptsFidelity", 0);
    let ACL = new Parse.ACL();
    ACL.setPublicReadAccess(true);
    ACL.setPublicWriteAccess(false);
    ACL.setReadAccess(Parse.User.current(), true);
    ACL.setWriteAccess(Parse.User.current(), true);
    user.setACL(ACL);
    user.save(null, {
      success: function(user) {
        // Execute any logic that should take place after the object is saved.
      },

      error: function(user, error) {
        // Execute any logic that should take place if the save fails.
        // error is a Parse.Error with an error code and message.
        console.log("erreur première étape");
        return message.error("Une erreur est survenue, vérifie ta connexion !");
      }
    });
  });
}
const WrappedSignUpForm = Form.create()(SignUpForm);

const mapDispatchToProps = dispatch => {
  return {
    submitForm: values => {
      dispatch(submitForm(values));
      saveParseUserStep1(values);
    },
    onHideAge: e => {
      dispatch(onChangeChecked(e));
    }
  };
};

const mapStateToProps = globalReducers => globalReducers;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedSignUpForm);
